<template>
  <div class="chartDom" ref="chartDom"></div>
</template>

<script setup>
import * as echarts from "echarts";
import { ref, computed, onMounted, watch } from "vue";

const chartDom = ref(null);

const props = defineProps({
  dataset: {
    type: Object,
    default: () => {
      return {
        pending: 0,
        canceled: 0,
        approved: 0,
      };
    },
  },
});

watch(
  () => props.dataset.pending,
  (newVal, oldVal) => {
    charInit();
  }
);

const option = computed(() => {
  return {
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b}: {c} ({d}%)",
      position: function (point, params, dom, rect, size) {
        // Get container dimensions
        var x = point[0];
        var y = point[1];

        const margin = 10;
        x = size.viewSize[0] / 2 - dom.offsetWidth / 2;
        /*
        if (x + dom.offsetWidth + margin > size.viewSize[0]) {
          x = size.viewSize[0] + dom.offsetWidth - margin;
        } else if (x < margin) {
          x = margin;
        } else {
          x = x + margin;
        }
        */

        if (y + dom.offsetHeight + margin > size.viewSize[1]) {
          y = size.viewSize[1] - dom.offsetHeight - margin;
        } else if (y > size.viewSize[1] / 2) {
          y = y + 10 - margin;
        } else {
          y = y - dom.offsetHeight - margin;
        }

        return [x, y];
      },
    },
    legend: {
      orient: "horizontal",
      left: "center",
      data: ["Pendientes", "Canceladas", "Aprobadas"],
    },
    series: [
      {
        name: "Estado",
        type: "pie",
        padAngle: 5,
        radius: ["50%", "70%"],
        borderRadius: 10,
        itemStyle: {
          borderRadius: 4,
        },
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: "center",
        },
        emphasis: {
          label: {
            show: true,
            fontSize: "30",
            fontWeight: "bold",
          },
        },
        labelLine: {
          show: true,
        },
        data: [
          {
            value: props?.dataset?.pending || 0,
            name: "Pendientes",
            itemStyle: { color: "#1E90FF" },
          },
          {
            value: props?.dataset?.cancelled || 0,
            name: "Canceladas",
            itemStyle: { color: "#FFD700" },
          },
          {
            value: props?.dataset?.approved || 0,
            name: "Aprobadas",
            itemStyle: { color: "#DA70D6" },
          },
        ],
      },
    ],
    graphic: [
      {
        type: "text",
        left: "center",
        top: "45%",
        style: {
          text: "",
          fontSize: 30,
          fontWeight: "bold",
          fill: "#333",
          textAlign: "center",
        },
      },
    ],
  };
});

const charInit = () => {
  var myChart = echarts.init(chartDom.value);
  myChart.setOption(option.value);
};

onMounted(() => {
  charInit();
});
</script>
<style setup>
.chartDom {
  width: 100%;
  height: 360px;
  box-sizing: border-box;
}
</style>
